/**
 * challengeConfig.js (client) — mirror of the server's challenge targets, per deployment.
 *
 * This is ONLY an optimization: it lets the client skip reporting progression for games
 * that clearly aren't a challenge, so we don't fire mutations during ordinary play. The
 * SERVER is authoritative and re-verifies every report (see server/challengeConfig.js +
 * reportChallengeProgress), so correctness never depends on this file.
 *
 * The target ids are sourced from appConfig (which is already per-deployment: main vs temp
 * point at different template records), so there's no separate env var to keep in sync.
 * Add more ids here as challenges grow.
 */
import { appConfig } from '../app/app.config';

// Challenge target template ids on THIS deployment.
const IDS = [appConfig.tutorialTemplateId, appConfig.starterTemplateId, appConfig.brainstormTemplateId].filter(Boolean);

// Should the client bother reporting progression for a game hosted from this builderID?
export const isChallengeGame = (builderID) => {
    if (!builderID) return false;
    if (IDS.length === 0) return true; // nothing configured -> defer to the server
    return IDS.indexOf(String(builderID)) !== -1;
};

export default { isChallengeGame };
